import React, { useRef } from 'react';
import { Radio, Space, InputNumber, Input, Flex, Button, Form, Image, Checkbox } from 'antd';
import { ConfigProvider } from 'antd';
import { Select } from 'antd';
import './App.css';
import { Typography } from 'antd';
import headerText from './header-text.png';
import headerTextEN from './header-text-en.png';
import headerLogoEN from './logo-header-en.png';
import headerTextMobile from './header-mobile-text.png';
import headerTextMobileEN from './header-text-en-mobile.png';
import headerLogo from './header-logo.png';
import { useEffect } from 'react';
import { Footer } from 'antd/es/layout/layout';
import { places } from './places';
import {texts, Lang, Texts} from './lang'
const { Title } = Typography;
const TRANZILLA_URL_TEMPLATE = `https://direct.tranzila.com/achim5/iframenew.php?currency=1&nologo=1&u71=1&cred_type=1`

function App() {
  const frameRef = useRef<null | HTMLDivElement>(null);
  // Read lang query param
  const urlParams = new URLSearchParams(window.location.search);
  const lang: Lang = (urlParams.get('lang') === 'en' ? 'en' : 'he') as 'en' | 'he';
  const [sendMarketing, setSendMarketing] = React.useState(true);
  const [paymentType, setTymentType] = React.useState('onTime');
  const [amount, setAmount] = React.useState<number>(0);
  const [customAmount, setCustomAmount] = React.useState<number>(0);
  const [url, setUrl] = React.useState('');
  const [erreMsg, setErrMsg] = React.useState('');
  const [fullName, setFullname] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [showIframe, seShowIframe] = React.useState(false);
  const [setelemet, setSetelemet] = React.useState('תל אביב');

  const [finalAmount, setFinalAmount] = React.useState(0);
  const onSetPredfineAmount = (amount: number) => {
    setFinalAmount(amount);
    setAmount(amount);
    setCustomAmount(0);
  }
  const onSetCustomAmount = (amount: number) => {
    const amountNum = parseInt(amount.toString())
    if (!isNaN(amountNum)) {
      setFinalAmount(amountNum);
      setAmount(0);
      setCustomAmount(amountNum);
    }
  }

  const onNext = () => {
    console.log('paymentType', { paymentType, finalAmount, customAmount, amount, fullName, email, phone });
    if (finalAmount === 0) {
      setErrMsg('יש לבחור סכום תרומה');
      return;
    }
    console.log(fullName === '', email === '', phone === '')
    if (fullName === '' || email === '' || phone === '') {

      setErrMsg('יש למלא פרטים אישיים');
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const standLocation = urlParams.get('standLocation');
    
    let url = TRANZILLA_URL_TEMPLATE.slice()
    console.log("In next",{ lang });
    url = setLang(url, lang);
    url = setSum(url, finalAmount);
    url = setRecurring(url, paymentType === 'recurring' ? true : false);
    url = setUserInfo(url, phone, fullName, email);
    url = setStandLocation(url, standLocation);
    url = setSendMarketingUrl(url, sendMarketing);
    url = setSelelmentUrl(url, setelemet);
    (frameRef.current as HTMLIFrameElement)!.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
    seShowIframe(true);
    setErrMsg('');
    setUrl(url);
  }

  function setLang(url: string, lang: string): string {
    if(lang==="en") {
      console.log("In lang en");
      url += '&buttonLabel=Donate';
    } else {
      console.log("In lang il");
      url += '&lang=il';
      url += '&buttonLabel=לתרומה';
    }
    return url;
  }
  function setStandLocation(url: string, standLocation: string | null): string {
    if (standLocation) {
      url += '&location=' + standLocation;
    }
    return url
  }
  function setSum(url: string, sum: any): string {
    url += '&sum=' + sum;
    return url;
  }
  function setRecurring(url: string, recurring: boolean): string {
    console.log({ recurring });
    if (recurring === true) {
      url += '&recur_transaction=4_approved&bit_pay=0';
    } else {
      url += '&bit_pay=1&google_pay=1';
    }
    return url;
  }
  function setUserInfo(url: string, phone: string, fullName: string, email: string): string {
    url += '&email=' + email + '&contact=' + fullName + '&phone=' + phone;
    return url;
  }

  function setSelelmentUrl(url: string, setelment: string): string {
    url += '&settlement=' + setelment;
    return url;
  }

  function setSendMarketingUrl(url: string, sendMarketing: boolean): string {
    url += '&sendMarketing=' + sendMarketing;
    return url;
  }
  function onSettlementChange(value: any) {
    console.log(`selected ${value}`);
    setSetelemet(value);
  }
  function onSettlementSearch(value: any) {
    console.log(`onSettlementSearch ${value}`);
  }
  
  const t: Texts = texts[lang];
  useEffect(() => {
    document.documentElement.lang = lang;
    document.body.dir = lang === 'he' ? 'rtl' : 'ltr';
  }, [lang]);
  
  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: '#3B3B1D',
          // Alias Token
          //colorBgContainer: '#f6ffed',
        },
      }}
    >
      <div className="App">
        <header className='page' >
          <section className='headerStyle'>
            <Image src={lang === 'he' ? headerText : headerTextEN} alt={lang === 'en' ? 'Brothers and Sisters in Arms at the forefront of Israel’s struggle' : 'אחים ואחיות לנשק בחזית המאבק של ישראל'} className='headerTextDesktop' preview={false}/>
            <Image src={lang === 'he' ? headerTextMobile : headerTextMobileEN} alt={lang === 'en' ? 'Brothers and Sisters in Arms at the forefront of Israel’s struggle' : 'אחים ואחיות לנשק בחזית המאבק של ישראל'} className='headerTextMobile' preview={false}/>
            <div className='headerContent'>
              <p className='headerText'>
                {t.header.split('\n').map((line: string, idx: number) => <React.Fragment key={idx}>{line}<br/></React.Fragment>)}
                <b>{t.headerBold.split('\n').map((line: string, idx: number) => <React.Fragment key={idx}>{line}<br/></React.Fragment>)}</b>
              </p>
            </div>
            <Image src={lang === 'he' ? headerLogo : headerLogoEN} alt={lang === 'en' ? 'Brothers in Arms Logo' : 'לוגו אחים לנשק'} preview={false} className='imageLogo'/>
          </section>
        </header>
        <Form>
          <div className="mainPage">
            <section>
              <h2>{t.chooseDonationType}</h2>
              <Space>
                <Radio.Group size="large" value={paymentType} onChange={(e) => setTymentType(e.target.value)}>
                  <Radio.Button value="onTime">{t.oneTime}</Radio.Button>
                  <Radio.Button value="recurring">{t.recurring}</Radio.Button>
                </Radio.Group>
              </Space>
            </section>
            <section>
              <h2>{t.chooseAmount}</h2>
              <Radio.Group size="large" value={amount} onChange={(e) => onSetPredfineAmount(e.target.value)}>
                {lang === 'he' ? 
                <table>
                  <tr>
                    <td><Radio.Button className='amountRadio' value="50">{t.donation50INS}</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="100">{t.donation100INS}</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="300">{t.donation300INS}</Radio.Button></td>
                  </tr>
                  <tr>
                    <td><Radio.Button className='amountRadio' value="500">{t.donation500INS}</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="1000">{t.donation1000INS}</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="2000">{t.donation2000INS}</Radio.Button></td>
                  </tr>
                </table>
                :

                <table>
                  <tr>
                    <td><Radio.Button className='amountRadio' value="71">€18</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="198">€50</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="395">€100</Radio.Button></td>
                  </tr>
                  <tr>
                    <td><Radio.Button className='amountRadio' value="710">€180</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="1972">€500</Radio.Button></td>
                    <td><Radio.Button className='amountRadio' value="3943">€1000</Radio.Button></td>
                  </tr>
                </table>
}
              </Radio.Group>
            </section>
            <section>
              <p>
                <h2>{t.otherAmount}</h2>
                <InputNumber size='large' type="text" defaultValue={0} addonAfter="₪" step="1" onChange={(e: any) => onSetCustomAmount(e)} />
              </p>
            </section>
            <section className='lastSection'>
              <h2>{t.total}
                ₪{finalAmount}
              </h2>
              {lang === 'en' ? 
              <div><b>* The donation will be charged in NIS</b></div>:<></>}
            </section>
            {showIframe ? null : <section className='userInfo'>
              <p>
                {t.confirm}
              </p>
              <p>
                <h3>{t.personalDetails}</h3>
              </p>
              <Flex className='docationForm' wrap="wrap" gap="middle" align="center" >
                <div>
                  <div>{t.fullName}</div>
                  <Input style={{ minWidth: "250px", maxWidth: "450px" }} autoComplete='true' name='fullName=' size='large' onChange={(e) => setFullname(e.target.value)} placeholder={t.fullName} />
                </div>
                <div>
                  <div>{t.phone}</div>
                  <Input style={{ minWidth: "250px", maxWidth: "450px" }} autoComplete='true' name='phoneNumber' size='large' onChange={(e) => setPhone(e.target.value)} placeholder={t.phone} />
                </div>
                <div>
                  <div>{t.email}</div>
                  <Input style={{ minWidth: "250px", maxWidth: "450px" }} autoComplete='true' name='email' size='large' onChange={(e) => setEmail(e.target.value)} placeholder={t.email} />
                </div>
                {lang === 'he' ?<div>
                  <div>{t.settlement}</div>
                  <Select
                    showSearch
                    style={{ minWidth: "250px", maxWidth: "450px"}}
                    placeholder={t.settlement}
                    optionFilterProp="label"
                    onChange={onSettlementChange}
                    onSearch={onSettlementSearch}
                    options={places}
                    defaultValue={setelemet}/>
                </div>
                :<></>}
              </Flex>
              <div className='btnsNext'>
                <Checkbox checked={sendMarketing} onChange={(e) => setSendMarketing(e.target.checked)}>
                  {t.marketing}
                </Checkbox>
              </div>
              <div className='btnsNext'>
                <Button type="primary" size='large' style={{ width: '80%', minWidth: "300px", maxWidth: "450px" }} onClick={() => onNext()}>{t.next}</Button>
                <Title level={3} type="danger">{erreMsg}</Title>
              </div>
            </section>}

          </div>
        </Form>
        {showIframe ? <iframe style={{ minHeight: "400px" }} allowpaymentrequest="ture" title='pyment' className='iFrame' src={url} width="100%" height="100%" ></iframe> : null}
        <div ref={frameRef}></div>
      
        <div className='content'>
        <div className='container'>
          <h2 className='section-title'>{t.ourFights}</h2>
        
        <div className='boxes-container'>
      <div className='box'>
        <div className='pattern image-box-1'> </div>
        <div className='box-content'>
          <h3 className='box-title'>{t.box1Title}</h3>
          <p>{t.box1Text}</p>
        </div>
      </div>
      <div className='box'>
        <div className='pattern image-box-3'></div>
        <div className='box-content'>
          <h3 className='box-title'>{t.box2Title}</h3>
          <p>{t.box2Text}</p>
        </div>
      </div>
      <div className='box'>
        <div className='pattern image-box-4'></div>
        <div className='box-content'>
          <h3 className='box-title'>{t.box3Title}</h3>
          <p>{t.box3Text}</p>
        </div>
      </div>
      <div className='box'>
        <div className='pattern image-box-2'></div>
        <div className='box-content'>
          <h3 className='box-title'>{t.box4Title}</h3>
          <p>{t.box4Text}</p>
         </div>
      </div>
        </div>
      </div>
      </div>
      <div>
        <Footer>
          <table>
            <tr>
              <td> | <a target='blank' href='https://www.bnsia.org/%d7%9e%d7%93%d7%99%d7%a0%d7%99%d7%95%d7%aa-%d7%a4%d7%a8%d7%98%d7%99%d7%95%d7%aa/'>מדיניות פרטיות</a></td>
              <td> | <a target='blank' href='https://www.bnsia.org/%d7%aa%d7%a0%d7%90%d7%99-%d7%94%d7%a9%d7%99%d7%9e%d7%95%d7%a9-%d7%91%d7%90%d7%aa%d7%a8-%d7%a2%d7%9e%d7%95%d7%aa%d7%aa-%d7%90%d7%97%d7%99%d7%9d-%d7%95%d7%90%d7%97%d7%99%d7%95%d7%aa-%d7%9c%d7%a0%d7%a9/'>תנאי שימוש</a></td>
              <td> | <a target='blank' href='https://www.bnsia.org/%d7%91%d7%a7%d7%a9%d7%94-%d7%9c%d7%a2%d7%a6%d7%99%d7%a8%d7%aa-%d7%94%d7%95%d7%a8%d7%90%d7%aa-%d7%a7%d7%91%d7%a2-%d7%9c%d7%a2%d7%9e%d7%95%d7%aa%d7%aa-%d7%90%d7%97%d7%99%d7%9d-%d7%95%d7%90%d7%97%d7%99/'>ביטול הוראת קבע</a></td>
            </tr>
          </table>
        </Footer>
      </div>
      </div>
    </ConfigProvider>);
}

export default App;


